import { render, staticRenderFns } from "./SetupCompletion.vue?vue&type=template&id=773b6250&scoped=true"
import script from "./SetupCompletion.vue?vue&type=script&lang=js"
export * from "./SetupCompletion.vue?vue&type=script&lang=js"
import style0 from "./SetupCompletion.vue?vue&type=style&index=0&id=773b6250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773b6250",
  null
  
)

export default component.exports